<template>
  <el-row class="bpo-footer">
    <el-col class="col-text-align">
      <footer style="background-image: linear-gradient(to right, #F8FFFF, #64B0B2, #78B3C4);">
        <span style="float:right;color:white;margin-right:10px;font-size:12px;"/>
        <p style="white-space: nowrap;margin: 0;font-weight: 400;font-size: 14px;color: #606266">
          <el-link href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202002648" target="_blank">浙公网安备33010202002648号</el-link>&nbsp;&nbsp;
          ©浙江信服会计师事务所有限公司 All Rights Reserved.&nbsp;&nbsp;
          <el-link href="https://beian.miit.gov.cn" target="_blank">浙ICP备2023017537号</el-link>
        </p>
      </footer>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'SWSFooter'
}
</script>

<style scoped>
/* 在全局样式文件中或者页面内样式标签中添加以下CSS */
.el-link:hover {
  color: blue; /* 鼠标悬停时显示黑色字体 */
}
</style>
